import { lazy, Suspense } from 'react';

import { Navigate, RouteObject } from 'react-router-dom';

import { ModalTrobber } from 'helpers/modal/Trobber';
import { PageLayout } from 'helpers/pageLayout';
import { sentryCreateBrowserRouter } from 'config/sentry';

const ViewsAuthEmail = lazy(() => import('views/auth/login'));
const ViewsAuthConfirmation = lazy(() => import('views/auth/confirmation'));

export const appRouterAuth: RouteObject[] = [
  {
    element: (
      <Suspense fallback={<ModalTrobber />}>
        <PageLayout withSideBar={false} isAuth />
      </Suspense>
    ),
    children: [
      {
        path: 'auth',
        children: [
          {
            path: 'login',
            element: <ViewsAuthEmail />
          },
          {
            path: 'confirmation',
            element: <ViewsAuthConfirmation />
          }
        ]
      },
      {
        path: '*',
        element: <Navigate to='auth/login' />
      }
    ]
  }
];

export const routerAuth = sentryCreateBrowserRouter(appRouterAuth);
